(function (global, factory) {
  if (typeof define === "function" && define.amd) {
    define(["exports", "normalizr", "@braindate/util/lib/assert", "./notificationAssertions", "../schema"], factory);
  } else if (typeof exports !== "undefined") {
    factory(exports, require("normalizr"), require("@braindate/util/lib/assert"), require("./notificationAssertions"), require("../schema"));
  } else {
    var mod = {
      exports: {}
    };
    factory(mod.exports, global.normalizr, global.assert, global.notificationAssertions, global.schema);
    global.notificationNormalization = mod.exports;
  }
})(typeof globalThis !== "undefined" ? globalThis : typeof self !== "undefined" ? self : this, function (_exports, _normalizr, _assert, _notificationAssertions, _schema) {
  "use strict";

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.hydrateNotification = hydrateNotification;
  _exports.hydrateNotifications = hydrateNotifications;
  _exports.normalizeNotification = normalizeNotification;
  _exports.normalizeNotifications = normalizeNotifications;

  /**
   * Normalize an notification
   * @param   {Notification} notification - Notification to normalize
   * @returns {number} data.result - Id of the notification
   * @returns {NormalizedData<number>} data.entities - Normalized data entities
   *
   * @throws Will throw an exception if parameter is not an object
   */
  function normalizeNotification(notification) {
    (0, _notificationAssertions.assertNotification)(notification);
    return (0, _normalizr.normalize)(notification, _schema.notificationSchema);
  }

  /**
   * Normalize notifications
   * @param   {Array<Notification>} notifications - Notifications to normalize
   * @returns {Array<number>} data.result - Ids of the notifications
   * @returns {NormalizedData<Array<number>>} data.entities - Normalized data
   * entities
   *
   * @throws Will throw an exception if parameter is not an array
   */
  function normalizeNotifications(notifications) {
    (0, _assert.assertArray)(notifications, "notifications");
    return (0, _normalizr.normalize)(notifications, _schema.notificationsSchema);
  }

  /**
   * Denormalize an notification
   * @param   {number} id - Id of the notification
   * @param   {Entities} entities - Normalized data entities
   * @returns {Notification} Denormalized notification
   *
   * @throws Will throw an exception if parameters are invalid
   */
  function hydrateNotification(id, entities) {
    (0, _assert.assertNumber)(id, "id");
    (0, _assert.assertObject)(entities, "entities");
    return (0, _normalizr.denormalize)(id, _schema.notificationSchema, entities);
  }

  /**
   * Denormalize notifications
   * @param   {Array<number>} ids - Ids of the notifications
   * @param   {Entities} entities - Normalized data entities
   * @returns {Array<Notification>} Denormalized notifications
   *
   * @throws Will throw an exception if parameters are invalid
   */
  function hydrateNotifications(ids, entities) {
    (0, _assert.assertArray)(ids, "ids");
    (0, _assert.assertObject)(entities, "entities");
    return (0, _normalizr.denormalize)(ids, _schema.notificationsSchema, entities);
  }
});